module.exports = __webpack_public_path__ + "static/media/deccan-equipments.de8bdc5c.png";